export const customersMask = value =>
  value
    .replace(/[0-9]/g, '')
    .replace(/-./i, '')
    .replace(/[{()}]/g, '')
    .trim();

export const cpfOrCnpjMask = value => {
  if (value.length === 11) {
    return value
      .replace(/[^\d]/g, '')
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (value.length === 14) {
    return value.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5',
    );
  }

  return value;
};
